var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 2.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 .75.75V14h-2.5V2.75zm-4.75 5.5c0-.467 0-.701.1-.875a.75.75 0 0 1 .275-.275C7.299 7 7.533 7 8 7s.701 0 .875.1a.75.75 0 0 1 .275.275c.1.174.1.408.1.875V14h-2.5V8.25zm-4 1.75a.75.75 0 0 0-.75.75V14h2.5v-3.25a.75.75 0 0 0-.75-.75h-1z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBar);
export default ForwardRef;